$ = jQuery; // in case of no-conflict jquery

hufxxx.site = new hufxxx.HufSite({ // config data
  cartDataBaseURL: 'https://hufworldwide.com',
  //slowCartAjax: true,
  //fakeCartAjax: true,
  cartAjaxEnabled: true
});

// on page loaded
$(function() {
  hufxxx.site.init();
});